import React, { useEffect, useState } from 'react';
import '../../../scss/pages/Employee helpdesk/RaiseRequest/raiseRequest.scss';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Backdrop, CircularProgress, Modal, TextareaAutosize, Typography } from '@mui/material';
import { Box } from '@mui/system';
import RaiseReqImage from '../../../asset/image/RaiseReqImage.png';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import HorizontalRuleRoundedIcon from '@mui/icons-material/HorizontalRuleRounded';
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';
import LeftArrow from '../../../asset/svg/leftArrow.svg';
import { useNavigate } from 'react-router';
import { EMPLOYEE_HELPDESK_PATH, EMPLOYEE_HELPDESK_VIEW_IMAGES } from '../../../utils/Constants';
import pdfFIleIcon from '../../../asset/svg/pdfFile.svg'
import { useDispatch, useSelector } from 'react-redux';
import { GET_EMPLOYEE_HELPDESK_CATEGORY, POST_CREATE_TICKET_EMPLOYEE_HELPDESK, POST_UPLOAD_FILE } from '../../../sagas/type';
import { generateNumRandomId } from '../../../components/common/GenerateRandomId/GenerateRandomId';
import { getLocalStoreString } from '../../../utils/Helper';
import { useSnackbar } from 'notistack';


function RaiseRequest() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { categoryData } = useSelector(mapStateToProps);
    const [subCategoriesData, setSubcategories] = useState([])
    const [selectCategoryModal, setSelectCategoryModal] = useState(false);
    const [selectSubCategoryModal, setSelectSubCategoryModal] = useState(false);
    const [selectedCategory, setSelectedCategopry] = useState('');
    const [selectedSubCategory, setSelectedSubCategopry] = useState('');
    const [writeYourIssue, setWriteYourIssue] = useState('');
    const [uploadFileData, setUploadFileData] = useState([]);
    const [isFormValid, setFormValid] = useState(false);
    const [loader, setLoader] = useState(false);
    const [selectSubCategoryID, setSelectSubCategoryID] = useState()

    const handleBack = () => {
        navigate(EMPLOYEE_HELPDESK_PATH)
    }
    const handleSelectCategory = () => {
        setLoader(true)
        dispatch({
            type: GET_EMPLOYEE_HELPDESK_CATEGORY,
            setLoader: setLoader,
        })
        setSelectCategoryModal(true)
    }
    const handleSelectCategoryType = (category) => {
        const filterData = categoryData?.length && categoryData?.filter((item) => {
            return item?.id === category?.id
        })
        setSelectedSubCategopry('')
        setSubcategories(filterData[0]?.subCategories)
        setSelectCategoryModal(false)
        setSelectedCategopry(category?.name)
    }

    const handleSelectSubCategory = () => {
        setSelectSubCategoryModal(true)
    }
    const handleSelectSubCategoryType = (Subcategory) => {
        setSelectSubCategoryID(Subcategory?.id)
        setSelectSubCategoryModal(false)
        setSelectedSubCategopry(Subcategory?.name)
    }

    const handleWriteYourIssue = (e) => {
        setWriteYourIssue(e.target.value)
    }

    const handleDeleteUploadImage = (id) => {
        const filterData = uploadFileData?.filter((item) => {
            return item?.id !== id
        })
        setUploadFileData(filterData)
    }

    const handleShowImage = (image) => {
        const arrFiles = []
        arrFiles.push(image)
        if (arrFiles.length > 0) {
            navigate(EMPLOYEE_HELPDESK_VIEW_IMAGES, { state: { files: arrFiles, raiseRequest: "isRequestPage" } })
        }
    }

    const resizeImage = async (file, maxWidthOrHeight) => {
        const img = new Image();

        return new Promise((resolve) => {
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                const aspectRatio = img.width / img.height;
                let width, height;

                if (img.width > img.height) {
                    width = Math.min(maxWidthOrHeight, img.width);
                    height = width / aspectRatio;
                } else {
                    height = Math.min(maxWidthOrHeight, img.height);
                    width = height * aspectRatio;
                }

                canvas.width = width;
                canvas.height = height;

                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob((blob) => {
                    resolve(blob);
                }, file.type);
            };

            img.src = URL.createObjectURL(file);
        });
    };


    const ImageCompression = async (image) => {
        let options = {
            maxWidthOrHeight: 2500,
        };
        let totalSize = image?.size;

        let tempImages;
        if (totalSize > 2 * 1024 * 1024) {
            do {
                options.maxWidthOrHeight = options.maxWidthOrHeight * 0.99;
                tempImages = await resizeImage(image, options.maxWidthOrHeight);
                totalSize = tempImages?.size
            } while (totalSize > 2 * 1024 * 1024);
            return tempImages;
        } else {
            return image
        }
    }


    const handleUploadFile = async (e) => {
        setLoader(true)
        const files = e?.target?.files[0];
        const compressedImages = await ImageCompression(files);
        dispatch({
            type: POST_UPLOAD_FILE,
            payload: { file: compressedImages },
            setUploadFileData: setUploadFileData,
            uploadFileData: uploadFileData,
            enqueueSnackbar: enqueueSnackbar,
            setLoader: setLoader,
        })
    }

    const renderUploadedFile = (fileObj, index) => {
        if (fileObj?.attachmentType === "application/pdf") {
            return (
                <div key={index} style={{ borderRadius: "8px", width: "75px", height: "90px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: 'rgba(255, 255, 255, 0.03)' }}>
                    <img src={pdfFIleIcon} style={{ backgroundColor: 'rgba(255, 255, 255, 0.03)' }} />
                </div>
            )
        } else {
            return (
                <div key={index} style={{ width: "75px", height: "90px", borderRadius: "8px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img src={fileObj?.attachmentUrl} alt='' style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px" }} />
                </div>
            );
        }
    }

    useEffect(() => {
        const isCategorySelected = selectedCategory !== '';
        const isSubCategorySelected = selectedSubCategory !== '';
        const isIssueDescriptionValid = writeYourIssue?.length >= 1;

        setFormValid(isCategorySelected && isSubCategorySelected && isIssueDescriptionValid);
    }, [selectedCategory, selectedSubCategory, writeYourIssue, uploadFileData]);

    const handleClickSubmit = () => {
        setLoader(true)
        if (isFormValid) {
            const EmployeeID = getLocalStoreString('EmployeeId');
            const TenantId = getLocalStoreString("CompanyID");
            const traceId = generateNumRandomId(8);
            const emptyArray = [
                {
                    id: 0,
                    attachmentUrl: "",
                    attachmentType: ""
                }]
            const attachmentDocument = uploadFileData?.map((item) => ({
                id: item?.id,
                attachmentUrl: item?.attachmentUrl,
                attachmentType: item?.attachmentType
            }))
            const createTicket = {
                traceId: traceId,
                employeeId: EmployeeID,
                companyId: TenantId,
                title: "",
                description: writeYourIssue,
                subCategoryId: selectSubCategoryID,
                attachments: attachmentDocument?.length > 0 ? attachmentDocument : emptyArray,
            }
            dispatch({
                type: POST_CREATE_TICKET_EMPLOYEE_HELPDESK,
                payload: createTicket,
                navigate: navigate,
                setLoader: setLoader,
            })
        }
    }

    return (
        <>
            <div className='Raise-Request-Container' >
                <div className='Raise-Request-Container_header'>
                    <div className='Raise-Request-Container_header_head-height'>
                        <img className='SelectItem-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                        <span className='Raise-Request-Container_header_head-height_content'>Raise a Request</span>
                    </div>
                </div>
                <div className='Raise-Request-Container_InputFields'>
                    <div className='Raise-Request-Container_Label'>
                        <Typography sx={{ color: "#fff", fontSize: "14px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif" }}>Category</Typography>
                    </div>
                    <div className='Raise-Request-Container_Category-Select' onClick={handleSelectCategory}>
                        <Typography sx={{ fontSize: "12px", color: "#FFF", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif" }}>{selectedCategory ? selectedCategory : 'Select Category'}</Typography>
                        <KeyboardArrowDownIcon sx={{ color: 'rgba(255, 255, 255, 0.40)', marginRight: "2px", height: '16px', width: '16px', fontFamily: "'Noto Sans', sans-serif" }} />
                    </div>
                    <Modal
                        open={selectCategoryModal}
                        onClose={() => setSelectCategoryModal(false)}
                        aria-labelledby="parent-modal-title"
                        aria-describedby="parent-modal-description"
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%" }}
                    >
                        <div className='Raise-Request-Container_Category-modal'>
                            <HorizontalRuleRoundedIcon sx={{ color: '#FFF', fontSize: "30px", position: "absolute", right: "50%", left: "47%", top: 0 }} onClick={() => setSelectCategoryModal(false)} />
                            {categoryData?.length > 0 ?
                                <Box sx={{ backgroundColor: '#0B245F', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', margin: "7% 4%", height: "400px", overflowY: "auto" }}>

                                    {categoryData?.map((item) => {
                                        return (
                                            <Box key={item?.id} sx={{ padding: "3% 0", borderBottom: "1px solid rgba(255, 255, 255, 0.08)", width: "100%" }} onClick={() => handleSelectCategoryType(item)}>
                                                <Typography sx={{ color: "#FFF", fontSize: "12px", fontWeight: 400, whiteSpace: "nowrap", width: "100%", fontFamily: "'Noto Sans', sans-serif" }}>{item?.name}</Typography>
                                            </Box>
                                        )
                                    })}

                                </Box> :

                                <Box sx={{ padding: "7% 4%", borderBottom: "1px solid rgba(255, 255, 255, 0.08)", width: "100%" }} >
                                    <Typography sx={{ color: "#FFF", fontSize: "12px", fontWeight: 400, whiteSpace: "nowrap", width: "100%", fontFamily: "'Noto Sans', sans-serif" }}>No Categories</Typography>
                                </Box>
                            }
                        </div>
                    </Modal>
                    <div className='Raise-Request-Container_Label'>
                        <Typography sx={{ color: "#fff", fontSize: "14px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif" }}>Sub Category</Typography>
                    </div>
                    <div className='Raise-Request-Container_Category-Select' onClick={handleSelectSubCategory}>
                        <Typography sx={{ fontSize: "12px", color: "#FFF", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif" }}>{selectedSubCategory ? selectedSubCategory : 'Select Sub Category'}</Typography>
                        <KeyboardArrowDownIcon sx={{ color: 'rgba(255, 255, 255, 0.40)', marginRight: "2px", height: '16px', width: '16px', fontFamily: "'Noto Sans', sans-serif" }} />
                    </div>
                    <Modal
                        open={selectSubCategoryModal}
                        onClose={() => setSelectSubCategoryModal(false)}
                        aria-labelledby="parent-modal-title"
                        aria-describedby="parent-modal-description"
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%" }}
                    >
                        <div className='Raise-Request-Container_Category-modal'>
                            <HorizontalRuleRoundedIcon sx={{ color: '#FFF', fontSize: "30px", position: "absolute", right: "50%", left: "47%", top: 0 }} onClick={() => setSelectSubCategoryModal(false)} />
                            {subCategoriesData?.length > 0 ?
                                <Box sx={{ backgroundColor: '#0B245F', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', margin: "7% 4%", height: "400px", overflowY: "auto" }}>
                                    {subCategoriesData?.map((item) => {
                                        return (
                                            <Box key={item?.id} sx={{ padding: "3% 0", borderBottom: "1px solid rgba(255, 255, 255, 0.08)", width: "100%" }} onClick={() => handleSelectSubCategoryType(item)}>
                                                <Typography sx={{ color: "#FFF", fontSize: "12px", fontWeight: 400, whiteSpace: "nowrap", width: "100%", fontFamily: "'Noto Sans', sans-serif" }}>{item?.name}</Typography>
                                            </Box>
                                        )
                                    })}
                                </Box> :
                                <Box sx={{ padding: "7% 4%", borderBottom: "1px solid rgba(255, 255, 255, 0.08)", width: "100%" }} >
                                    <Typography sx={{ color: "#FFF", fontSize: "12px", fontWeight: 400, whiteSpace: "nowrap", width: "100%", fontFamily: "'Noto Sans', sans-serif" }}>No Subcategories</Typography>
                                </Box>
                            }
                        </div>
                    </Modal>
                    <div className='Raise-Request-Container_Label'>
                        <Typography sx={{ color: "#fff", fontSize: "14px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif" }}>Write your Issue</Typography>
                    </div>
                    <div className='Raise-Request-Container_Write-your-issue'>
                        <TextareaAutosize id='textAreaId' value={writeYourIssue} minLength={4} maxRows={4} placeholder="Issue Description" style={{ overflow: "auto", width: "93%", height: "63px", fontSize: "12px", fontWeight: 400, borderRadius: "9px", backgroundColor: "transparent", border: "none", color: "#FFF", fontFamily: "'Noto Sans', sans-serif", resize: "none" }} onChange={handleWriteYourIssue} />
                    </div>
                    <div className='Raise-Request-Container_Label'>
                        <div className='Raise-Request-Container_Label_upload-temp'>
                            <Typography sx={{ color: "#fff", fontSize: "14px", fontWeight: 400, fontFamily: "'Noto Sans', sans-serif" }}>Add Photo / Document (if any)</Typography>
                        </div>
                        {uploadFileData?.length > 2 && uploadFileData?.length < 5 && <div className='Raise-Request-Container_Label_addphoto-temp'>
                            <label htmlFor="formId">
                                <input id="formId" type="file" onChange={handleUploadFile} multiple accept="application/pdf, image/*" />
                                <Typography sx={{ color: '#4B2EF1', fontSize: "12px" }}>Add Photo</Typography>
                            </label>
                        </div>}

                    </div>
                    <div className='Raise-Request-Container_Add-Photo'>
                        <Box sx={{ marginTop: "5px", width: "100%" }} className='Raise-Request-Container_Add-Photo_Data'>
                            {uploadFileData?.length == 0 ?
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <label htmlFor="formId" className='Raise-Request-Container_Add-Photo_Data_Label-Upload'>
                                        <input id="formId" type="file" onChange={handleUploadFile} multiple accept="application/pdf, image/*" />
                                        <CameraAltIcon sx={{ color: 'rgba(255, 255, 255, 0.40)', marginRight: "2px", height: '13px', width: '13px' }} />
                                        <Typography sx={{ whiteSpace: "nowrap", color: "rgba(255, 255, 255, 0.40)", fontSize: "14px", fontWeight: 500 }}>Upload</Typography>
                                    </label>
                                </Box>
                                :
                                <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", width: "300px", gap: "5%", overflow: "auto" }}>
                                    {uploadFileData?.map((fileObj, index) => {
                                        return (
                                            <div className='Raise-Request-Container_Add-Photo_Data_Upload-doc'>
                                                {renderUploadedFile(fileObj, index)}
                                                <ClearIcon sx={{ color: '#FFF', marginRight: "2px", height: '17px', width: '17px', position: "absolute", top: 4, right: 3 }} onClick={() => handleDeleteUploadImage(fileObj?.id)} />
                                            </div>
                                        )
                                    })}
                                    {uploadFileData?.length <= 2 && <label htmlFor="formId" className='Raise-Request-Container_Add-Photo_Data_Label-Add'>
                                        <div className='Raise-Request-Container_Add-Photo_Data_Label-Add_childDiv'>
                                            <input id="formId" type="file" onChange={handleUploadFile} multiple accept="application/pdf, image/*" />
                                            <AddIcon sx={{ width: "20px", height: "20px", color: "#FFF", opacity: "0.3" }} />
                                        </div>
                                    </label>}
                                </Box>
                            }
                        </Box>
                    </div>
                    <div>
                        <Typography sx={{ whiteSpace: "nowrap", color: "#FFF", fontSize: "10px", fontWeight: 400, opacity: 0.6, marginTop: "3px" }}>File size cannot be more than 5MB</Typography>
                    </div>
                    <div className='Raise-Request-Container_InputFields_Button'>
                        <button disabled={!isFormValid} className='Raise-Request-Container_InputFields_Button_active-button' onClick={handleClickSubmit}>Submit</button>
                    </div>

                </div>
            </div >
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        categoryData: state?.employeeHelpdesk?.CategoriesEMployeeHelpdesk,
    }
}

export default RaiseRequest